import React, { Component } from 'react';
// import {
//   connect
// } from "react-redux";
import { withStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import ScrollToTopOnMount from 'components/UI/ScrollToTopOnMount';
import Header from 'components/Header/Header';
// import Banner from "components/Banner/Banner";
// import i18n from "helpers/i18n";
// import {
// getCurrentUserRole
// } from "ducks/authentication";
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Fade from '@material-ui/core/Fade';
import Footer from '../Footer';
// import Immutable from "immutable";
// import queryString from "query-string";
const styles = (theme) => {
  return {
    root: {
      minHeight: '100%',
      height: '100%',
      '& .MuiTypography-h1': {
        [theme.breakpoints.down('sm')]: {
          textAlign: 'center',
        },
      },
    },
    header: {
      minHeight: 150,
      marginBottom: 5,
    },
    content: {
      height: 'calc(100% - 150px - 120px)',
    },
    footer: {
      height: 120,
      [theme.breakpoints.down('sm')]: {
        height: 'auto',
      },
    },
    paperWrapper: {
      width: '100%',
      display: 'block',
      // '&  .padder:last-of-type()': {
      //   margin: 0
      // }
    },
    paper: {
      // padding: theme.spacing(4),
    },
  };
};
class Template extends Component {
  render() {
    const {
      // onPanelToggle,
      classes,
      title,
      userRole,
      children,
      page,
    } = this.props;
    // const uri = queryString.parse(window.location.search);
    // const $$initValues = uri.s && uri.s === '3' ? Immutable.fromJS({
    //   subject: 'rpps'
    // }) : undefined;
    return (
      <Fade in timeout={1000} style={{ height: '100%' }}>
        <div className={classes.root}>
          <Container
            disableGutters
            fixed={false}
            maxWidth={false}
            style={{
              height: '100%',
              minHeight: '940px',
            }}
          >
            <ScrollToTopOnMount />
            <Container
              disableGutters
              fixed={false}
              maxWidth={'lg'}
              style={{
                minHeight: 'calc(100% - 142px)',
              }}
            >
              <div className={classes.header}>
                <Header userRole={userRole} current={page} />
              </div>

              <Grid className={classes.content} container alignItems={'center'}></Grid>
              <If condition={title !== false}>
                <Box className={classes.paperWrapper}>
                  <Paper square elevation={0} className={classes.paper}>
                    <Box bgcolor="tercary.light">
                      <Typography variant="h1">{title}</Typography>
                    </Box>
                  </Paper>
                </Box>
              </If>
              {children}
            </Container>
            <Footer className={classes.footer} />
          </Container>
        </div>
      </Fade>
    );
  }
}
export default withStyles(styles)(Template);



// WEBPACK FOOTER //
// ./src/components/Template/Template.jsx